import { render, staticRenderFns } from "./FormColors.vue?vue&type=template&id=3c62d60c&scoped=true&"
import script from "./FormColors.vue?vue&type=script&lang=js&"
export * from "./FormColors.vue?vue&type=script&lang=js&"
import style0 from "./FormColors.vue?vue&type=style&index=0&id=3c62d60c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c62d60c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VBtnToggle,VDivider,VFlex,VIcon,VLayout,VSlider,VSnackbar,VSwitch})
